import React from "react";
import Iteam from "./component/Iteam"





export default function App () {


    return (
        <div>
                <Iteam />
        </div>
    )
}